import * as H from "history";
import ReactGA from "react-ga";
import TagManager from "react-gtm-module";
import {useEffect} from "react";

const isTest = process.env.NODE_ENV !== "production";

const tagManagerArgs = {
    gtmId: "GTM-KMLDL27"
};

export const initializeGoogleTagManager = () => TagManager.initialize(tagManagerArgs);

export const initializeGoogleAnalytics = () => ReactGA.initialize("UA-152102414-1", {
    debug: false,
    testMode: isTest
});

export const googleAnalyticsTrackError = (error: any) => ReactGA.exception(error);

function usePageTracking(history: H.History) {
    const {location} = history;
    useEffect(() => {
        ReactGA.pageview(location.pathname);
    }, [location]);
}

export default usePageTracking;
